var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61217 18.0168L1.18359 19.8168L2.98359 13.3882L14.755 1.67396C14.888 1.5379 15.047 1.42978 15.2223 1.35597C15.3977 1.28216 15.5862 1.24414 15.7765 1.24414C15.9667 1.24414 16.1552 1.28216 16.3306 1.35597C16.5059 1.42978 16.6649 1.5379 16.7979 1.67396L19.3265 4.21682C19.4603 4.34962 19.5666 4.50763 19.6392 4.6817C19.7117 4.85579 19.749 5.04252 19.749 5.2311C19.749 5.41969 19.7117 5.60642 19.6392 5.7805C19.5666 5.95459 19.4603 6.11259 19.3265 6.24539L7.61217 18.0168Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.e3d152d86e55f1a66448130c7ae96ec8.svg";
export { ForwardRef as ReactComponent };